import { Account } from "@services/account/types";
import { MeetingInstance } from "@services/meetings/types";

export const formatData = (data: number, number: number) => {
  return `${data}`.padStart(number, "0");
};

const meetingStatus = {
  INPROGRESS: "InProgress",
  SCHEDULED: "Scheduled",
  CANCELLED: "Cancelled",
};

export const checkLive = (meeting: MeetingInstance) => {
  if (meeting.status?.toString().startsWith(meetingStatus.INPROGRESS))
    return true;
  var now = new Date();
  var startTime = new Date(meeting.start ?? "");
  var endTime = new Date(meeting.end ?? "");
  if (endTime.getTime() < now.getTime()) return false;
  if (now.getTime() > startTime.getTime()) return true;
  return false;
};

export const sortByDate = (a: MeetingInstance, b: MeetingInstance) => {
  if (!a.start || !b.start) return -1;
  return a.start < b.start ? -1 : 1;
};
export const sortByAccountName = (a: Account, b: Account) => {
  if (!a.name || !b.name) return -1;
  if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
  if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
  return 0;
};
